import { formatText } from 'core/i18n';

export const CRYPTO_CURRENCY_MOVEMENTS = 'cryptoCurrencyMovements';
export const BANK_AND_TRAVEL_CHECKS_MOVEMENTS = 'bankAndTravelChecksMovements';

export const getIncomesData = (handleDataToSave, handleClickOther) => {
    return [
        {
            label: formatText('field-income_item_b_1'),
            model: 'userProfile.income_work',
            onChange: value => {
                handleDataToSave('work', value);
            },
        },
        {
            label: formatText('field-income_item_b_2'),
            model: 'userProfile.income_activities',
            onChange: value => {
                handleDataToSave('activities', value);
            },
        },
        {
            label: formatText('field-income_item_b_4'),
            model: 'userProfile.income_business',
            onChange: value => {
                handleDataToSave('business', value);
            },
        },
        {
            label: formatText('field-income_item_b_5'),
            model: 'userProfile.income_realState',
            onChange: value => {
                handleDataToSave('realState', value);
            },
        },
        {
            label: formatText('field-income_item_b_6'),
            model: 'userProfile.income_other',
            onChange: value => {
                handleClickOther(value);
            },
        },
    ];
};
